export const WHITE_THEME = "WHITE_THEME";
export const DARK_THEME = "DARK_THEME";
